
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// const dashboard = resolve => require(['@/views/dashboard/Dashboard.vue'], resolve);

// const page404 = resolve => require(['@/views/errorPage/404.vue'], resolve);

// const index = resolve => require(['@/views/register/Index.vue'], resolve);
// const ServiceAgreement = resolve => require(['@/views/register/serviceAgreement.vue'], resolve);
const PrivacyStatement = resolve => require(['@/views/register/PrivacyStatement.vue'], resolve);
// const Instructions = resolve => require(['@/views/instructions/Instructions.vue'], resolve);
// const ReturnNote = resolve => require(['@/views/register/ReturnNote.vue'], resolve);
// const details = resolve => require(['@/views/sertaList/Entry.vue'], resolve);
// const CarManage = resolve => require(['@/views/sertaList/CarManage.vue'], resolve);
// const list = resolve => require(['@/views/sertaList/List.vue'], resolve);


Vue.use(Router);

export default new Router({
    routes: [
        // {
        //     path: '/',
        //     name: 'index',
        //     component: Instructions
        // },
        // {
        //     path: '/service-agreement',
        //     name: 'service-agreement',
        //     component: ServiceAgreement
        // },
        // {
        //     path: '/service-agreement',
        //     name: 'service-agreement',
        //     component: ServiceAgreement
        // },
        {
            path: '/',
            name: 'privacy-statement',
            component: PrivacyStatement
        }
        // {
        //     path: '/',
        //     name: 'list',
        //     component: list,
        //     meta: {
        //         keepAlive: true
        //     }
        // },
        // {
        //     path: '/details',
        //     name: 'details',
        //     component: details,
        //     meta: {
        //         keepAlive: false
        //     }
        // }
    ]
});
